import React from 'react';

import { FooterButtonContainer, FooterButtonIcon, FooterButtonLabel } from './styles';

export default function FooterButton({ icon, text, onClick, hoverColor }) {
  return (
    <FooterButtonContainer onClick={onClick} hoverColor={hoverColor}>
      {icon && <FooterButtonIcon icon={icon} />}
      <FooterButtonLabel>{text}</FooterButtonLabel>
    </FooterButtonContainer>
  );
}
